// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"303":"edcac06a86719267","525":"ba8fd6b7f534f2b3"}[chunkId] + ".js";
};